(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Rob custom */
  const megaMenuLinks = document.querySelectorAll('.mega-menu .list-menu__item');
  let closeDrawCancelToken = null;
  
  for (let i = 0; i < megaMenuLinks.length; i++) {
    megaMenuLinks[i]?.addEventListener('mouseenter', () => {
      megaMenuLinks[i]?.parentNode.setAttribute('open', true);
    }, false);

    megaMenuLinks[i]?.addEventListener('mouseleave', () => {
      closeDrawCancelToken = setTimeout(() => {
        megaMenuLinks[i].parentNode.setAttribute('closing', true);
        
        setTimeout(() => {
          megaMenuLinks[i].parentNode.removeAttribute('open');
          megaMenuLinks[i].parentNode.removeAttribute('closing');
        }, 350);
      }, 200);
    }, false);

    megaMenuLinks[i]?.parentNode?.querySelector('.mega-menu__content')?.addEventListener('mouseenter', (el) => {
      /* Cancel the above mega menu draw closing if we've gone down to the actual content */
      clearTimeout(closeDrawCancelToken);
      el.target.parentNode?.parentNode?.querySelector('.mega-menu')?.setAttribute('open', true);
    }, false);
    
    megaMenuLinks[i]?.parentNode?.querySelector('.mega-menu__content')?.addEventListener('mouseleave', (el) => {
      const targetElMegaMenu = el.target.parentNode?.parentNode?.querySelector('.mega-menu');
  
      if(targetElMegaMenu !== null && targetElMegaMenu !== undefined) {
        targetElMegaMenu?.setAttribute('closing', true);

        setTimeout(() => {
          targetElMegaMenu?.removeAttribute('open');
          targetElMegaMenu?.removeAttribute('closing');
        }, 350);
      }
    }, false);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function getProductJsonLdObjectAndSetResult(el) {

      const aria = el?.querySelector('.text-m').getAttribute('aria-label');
      const ratings = el?.querySelector('.yotpo-stars .sr-only')

      const yotpoNoReviews = aria.split(' reviews')[0];
      const yotpoRatings = ratings.textContent.split(' ')[0];

      if(Number(yotpoNoReviews) === 0) {
        return;
      }

      console.log(yotpoNoReviews);

      const scripts = document.querySelectorAll('script[type="application/ld+json"]');

      let result = null;

      for (const script of scripts) {
        let data;

        try {
          data = JSON.parse(script.textContent);
        } catch {
          continue;
        }

        // Case 1: single object
        if (data && data['@type'] === 'Product') {
          result = { script, root: data, product: data };
        }

        // Case 2: array of objects
        if (Array.isArray(data)) {
          const product = data.find(obj => obj && obj['@type'] === 'Product');
          if (product) {
            result = { script, root: data, product };
          }
        }

        // Case 3: @graph
        if (data && Array.isArray(data['@graph'])) {
          const product = data['@graph'].find(obj => obj && obj['@type'] === 'Product');
          if (product) {
            result = { script, root: data, product };
          }
        }
      }

      console.log(result);

      if (result) {
        result.product.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: yotpoRatings,
          ratingCount: yotpoNoReviews,
          reviewsCount: yotpoNoReviews
        };

        result.script.textContent = JSON.stringify(result.root);
      }
    }

    const widget = document.querySelector('.yotpo-bottomline');

    if (widget) {
      console.log('Yotpo already loaded');
      getProductJsonLdObjectAndSetResult(widget);
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        const widget = document.querySelector('.yotpo-bottomline');

        if (widget) {
          console.log('Yotpo loaded');
          getProductJsonLdObjectAndSetResult(widget);
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
